module.exports = __webpack_public_path__ + "img/cpr_coin.pirates.80db8e6.png";